import { Instance, types } from 'mobx-state-tree';

export const OddsPopularityStatsInApiStore = types.model({
    tipId: types.string,
    name: types.string,
    percentage: types.number,
})

export type OddsPopularityStatsInApi = Instance<typeof OddsPopularityStatsInApiStore>;
